import * as React from 'react';
import {cn} from '@/lib/utils';

const Typography = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({className, ...props}, ref) => (
  <div ref={ref} className={cn(className)} {...props} />
));
Typography.displayName = 'Typography';

const Title = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement> & {
    level?: 1 | 2 | 3 | 4 | 5;
  }
>(({className, level = 1, ...props}, ref) => {
  const sizeClasses = {
    1: 'text-4xl font-bold',
    2: 'text-3xl font-bold',
    3: 'text-2xl font-semibold',
    4: 'text-xl font-semibold',
    5: 'text-lg font-medium',
  };

  if (level === 1) {
    return (
      <h1 ref={ref} className={cn(sizeClasses[level], className)} {...props} />
    );
  } else if (level === 2) {
    return (
      <h2 ref={ref} className={cn(sizeClasses[level], className)} {...props} />
    );
  } else if (level === 3) {
    return (
      <h3 ref={ref} className={cn(sizeClasses[level], className)} {...props} />
    );
  } else if (level === 4) {
    return (
      <h4 ref={ref} className={cn(sizeClasses[level], className)} {...props} />
    );
  } else {
    return (
      <h5 ref={ref} className={cn(sizeClasses[level], className)} {...props} />
    );
  }
});
Title.displayName = 'Title';

export {Typography, Title};
